var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTick = function SvgTick(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.222 12.335h.001L5.809 13.75.003 7.944 1.418 6.53l4.39 4.39 8.77-8.77 1.415 1.414-8.77 8.77z",
    fill: "currentColor"
  })));
};
export { SvgTick as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTcuMjIyIDEyLjMzNWguMDAxTDUuODA5IDEzLjc1LjAwMyA3Ljk0NCAxLjQxOCA2LjUzbDQuMzkgNC4zOSA4Ljc3LTguNzcgMS40MTUgMS40MTQtOC43NyA4Ljc3eiIgZmlsbD0iY3VycmVudENvbG9yIi8+PC9zdmc+";